<template>
  <div id="app" class="app-layout">
    <!-- Navbar Layout -->
    <app-navbar />

    <!-- Main Viewport -->
    <main class="main-content">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>

    <!-- Footer Layout -->
    <app-footer />

    <!-- Global Toast Container -->
    <div class="toast-container">
      <div 
        v-for="toast in toasts" 
        :key="toast.id" 
        class="toast" 
        :class="{ 'toast-success': toast.type === 'success', 'toast-error': toast.type === 'error' }"
      >
        <span class="toast-icon">{{ toast.type === 'success' ? '✨' : '⚠️' }}</span>
        <span class="toast-text">{{ toast.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavbar from '@/components/Navbar.vue'
import AppFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter
  },
  data() {
    return {
      toasts: []
    }
  },
  created() {
    this.$root.$on('show-toast', this.showToast)
    this.loadSiteConfig()
  },
  beforeDestroy() {
    this.$root.$off('show-toast', this.showToast)
  },
  methods: {
    async loadSiteConfig() {
      try {
        const response = await fetch('/api/qzctech/site-config/get')
        const result = await response.json()
        if (response.ok && result.statusCode === 100200 && result.data) {
          this.$store.commit('SET_SITE_CONFIG', result.data)
          this.applySeo(result.data)
        }
      } catch (error) {
        console.error('加载官网配置失败，将使用页面默认内容。', error)
      }
    },
    applySeo(config) {
      if (config.seoTitle) document.title = config.seoTitle
      this.setMetaContent('description', config.seoDescription)
      this.setMetaContent('keywords', config.seoKeywords)
    },
    setMetaContent(name, content) {
      if (!content) return
      let element = document.querySelector(`meta[name="${name}"]`)
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute('name', name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    },
    showToast({ type = 'success', message, duration = 3000 }) {
      const id = Date.now() + Math.random().toString()
      this.toasts.push({ id, type, message })
      setTimeout(() => {
        this.toasts = this.toasts.filter(t => t.id !== id)
      }, duration)
    }
  }
}
</script>

<style>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding-top: 110px; /* Offset for sticky navbar */
  min-height: calc(100vh - 110px);
}

/* Route transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
